// extracted by mini-css-extract-plugin
export var actionText = "_rz-4";
export var container = "_rz-0";
export var leftSection = "_rz-1";
export var rightSection = "_rz-2";
export var settingsButton = "_rz-6";
export var settingsIcon = "_rz-7";
export var shortcut = "_rz-5";
export var shortcutGroup = "_rz-3";